import React, { useState, useEffect } from 'react';
import { Grid, Icon, LinearProgress, Step, StepConnector, StepLabel, Stepper, Typography  } from '@mui/material';
import {makeStyles, withStyles} from '@mui/styles'


/* `const BorderLinearProgress` is a customized version of the `LinearProgress` component from MUI. It
is created using the `withStyles` higher-order component, which takes in a function that returns an
object containing CSS styles. The styles in this object are applied to the `LinearProgress`
component to create a new component with customized styles. The `BorderLinearProgress` component has
a height of 8, a border radius of 4, a grey background color, and a secondary color for the progress
bar. */
const BorderLinearProgress = withStyles((theme) => ({
    root: {
      height: 8,
      borderRadius: 4,
    },
    colorPrimary: {
      backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 200],
    },
    bar: {
      borderRadius: 4,
      backgroundColor: theme.palette.secondary.main,
    },
  }))(LinearProgress);


/**
 * @module Layouts/Registration/components/CustomStepper
 * @description This is a functional component called `CustomStepper` that takes in two props: `activeStep` and
`steps`. It uses the `useStyles` hook from MUI to define some custom styles. It calculates the
progress of the stepper based on the current `activeStep` and the total number of `steps`. It then
returns a JSX element that displays a progress bar and the current progress percentage.
 * @returns {React.ReactElement} The `DocumentElement` component is being returned as a View.
 */

/**
 * 
 * @typedef CustomStepper
 * @property {MUIStyles} classes - The styles for the component 
 * @property {Object} activeStep - Active step
 * @property {Number} steps - Number of steps to show
*/


const CustomStepper = ({activeStep, steps}) => {

    const classes = useStyles()

    let progress = Math.round((activeStep/steps.length)*100)

   // console.log(progress)

    return ( 
        <div style={{marginTop:16}}>
            <Grid container alignItems='center' spacing={1}>
              <Grid item xs>
                <BorderLinearProgress value={progress} variant='determinate' />
              </Grid>
              <Grid item>
                <Typography style={{color:'white', fontWeight:600}}>{`${progress}%`}</Typography>
              </Grid>
            </Grid>
            
        </div>
     );
}

const useStyles = makeStyles(theme => ({
    step:{

    },
    icon:{
        fontSize:18,
        color:'white'
    }
}))
 
export default CustomStepper;

